import { Text } from '@fluentui/react';
import { PARTIDOS_EXTRA_ZONA_NAME } from '../../common/constants';
import { Zona } from '../../system/SystemClient';

export const ZonaFixture = ({ zona }: { zona: Zona }) => {
  return (
    <div>
      <div className="ms-Grid-col ms-sm12 text-center" style={{ borderTop: '1px solid #e8e8e8' }}>
        <div className="ms-Grid-row" style={{ marginTop: 15, marginBottom: 15 }}>
          <div className="ms-Grid-col ms-sm12">
            <Text variant="large" className="zona-label">
              {zona.nombre !== PARTIDOS_EXTRA_ZONA_NAME ? `Zona ${zona.nombre}` : `Partidos extras`}
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
};

export const FechaFixture = ({ fecha }: { fecha: String }) => {
  return (
    <div>
      <div className="ms-Grid-col ms-sm12 instancia-fecha">
        <div className="ms-Grid-row" style={{ marginTop: 10, marginBottom: 10 }}>
          <div className="ms-Grid-col ms-sm12">
            <Text variant="large" className="fecha-label">
              Fecha {fecha}
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
};
